import Axios, { AxiosRequestConfig } from "axios";
import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig() ?? {
  publicRuntimeConfig: {
    IS_PROD: false,
    IS_TEST: true,
  },
};
const AXIOS_INSTANCE = Axios.create({
  baseURL: publicRuntimeConfig.IS_PROD ? "/api/v2" : "/api/v2",
});

export const customInstance = <T>(config: AxiosRequestConfig): Promise<T> => {
  const source = Axios.CancelToken.source();
  const { url, ...rest } = config;

  const promise = AXIOS_INSTANCE({
    url: publicRuntimeConfig.IS_TEST ? `${url}?test=true` : url,
    ...rest,
    cancelToken: source.token,
  }).then(({ data }) => data);

  // @ts-ignore
  promise.cancel = () => {
    source.cancel("Query was cancelled by React Query");
  };

  return promise;
};
